<template>
  <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
  <div :class="componentClassName">
    <a-page-heading>契約情報確認・変更</a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section variant="fullpage">
      <m-action-card
        title="契約名義変更"
        label="*が付いている項目は、内容確認が必要となるため、約5営業日後の反映となります。"
        icon="user"
        :header-border="true"
        :narrow-body="true"
      >
        <form ref="form" class="t-contract-edit-contractor-info__form" @submit.prevent="handleFormSubmit">
          <div class="t-contract-edit-contractor-info__fields">
            <p>契約者情報</p>
            <m-form-input label="氏名 *">
              <!-- <a-text-field v-model="formData.adminName" /> -->
              <a-text-field
                id="lastname"
                v-model="formData.lastname"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('lastname')"
              />
              <a-text-field
                id="name"
                v-model="formData.name"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('name')"
              />
            </m-form-input>
            <m-form-input label="氏名カナ">
              <!-- <a-text-field v-model="formData.adminKanaName" /> -->
              <a-text-field
                id="lastname_kana"
                v-model="formData.lastname_kana"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :error="getFieldError('lastname_kana')"
              />
              <a-text-field
                id="name_kana"
                v-model="formData.name_kana"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :error="getFieldError('name_kana')"
              />
            </m-form-input>
            <m-form-input label="生年月日 *">
              <a-text-field
                id="adminBirthDate"
                v-model="formData.adminBirthDate"
                type="text"
                placeholder="19800101"
                maxlength="8"
                pattern="[0-9]{8}"
                required
                :error="getFieldError('adminBirthDate')"
              />
            </m-form-input>
            <!-- <m-form-input label="法人名">
              <a-text-field v-model="formData.company_name" />
            </m-form-input> -->
            <m-form-input label="メールアドレス">
              <!-- <a-text-field v-model="formData.adminEmail" /> -->
              <a-text-field
                id="adminEmail"
                v-model="formData.adminEmail"
                type="email"
                placeholder="キャリアメールは使えません"
                maxlength="50"
                :disabled="true"
                :error="getFieldError('adminEmail')"
              />
            </m-form-input>
            <m-form-input label="職業">
              <a-text-field
                id="adminJob"
                v-model="formData.adminJob"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('adminJob')"
              />
            </m-form-input>
            <m-form-input label="電話番号">
              <!-- <a-text-field v-model="formData.adminPhoneNumber" /> -->
              <a-text-field
                id="adminPhoneNumber"
                v-model="formData.adminPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
                :error="getFieldError('adminPhoneNumber')"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <!-- <a-text-field v-model="formData.adminPostCode" /> -->
              <a-text-field
                id="adminPostCode"
                v-model="formData.adminPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                required
                :error="getFieldError('adminPostCode')"
              />
            </m-form-input>
            <m-form-input label="都道府県名 *">
              <!-- <a-text-field v-model="formData.adminAddress1" /> -->
              <a-select-field
                id="adminAddress1"
                v-model="formData.adminAddress1"
                :options="prefectures"
                required
                :error="getFieldError('adminAddress1')"
              />
            </m-form-input>
            <m-form-input label="市区町村 *">
              <!-- <a-text-field v-model="formData.adminAddress2" /> -->
              <a-text-field
                id="adminAddress2"
                v-model="formData.adminAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('adminAddress2')"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など *">
              <!-- <a-text-field v-model="formData.adminAddress3" /> -->
              <a-text-field
                id="adminAddress3"
                v-model="formData.adminAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('adminAddress3')"
              />
            </m-form-input>
            <m-form-input label="住所建物など *">
              <!-- <a-text-field v-model="formData.adminAddress4" /> -->
              <a-text-field
                id="adminAddress4"
                v-model="formData.adminAddress4"
                type="text"
                placeholder="変更があれば入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="利用目的">
              <div class="a-text-field a-text-field--text" required>
                <textarea
                  id="purposeOfUse"
                  v-model="formData.purposeOfUse"
                  class="a-text-field__input"
                  placeholder="入力してください"
                  maxlength="100"
                  required
                  :error="getFieldError('purposeOfUse')"
                />
              </div>
            </m-form-input>
            <template v-if="formData.businessType === 'company'">
              <p>法人情報</p>
              <m-form-input label="契約名義 *">
                <!-- <a-text-field v-model="formData.companyName" /> -->
                <a-text-field
                  id="companyName"
                  v-model="formData.companyName"
                  type="text"
                  placeholder="入力してください"
                  maxlength="40"
                  required
                  :error="getFieldError('companyName')"
                />
              </m-form-input>
              <m-form-input label="契約名義カナ">
                <!-- <a-text-field v-model="formData.companyKanaName" /> -->
                <a-text-field
                  id="companyKanaName"
                  v-model="formData.companyKanaName"
                  type="text"
                  placeholder="全角カタカナ"
                  maxlength="40"
                  pattern="[ァ-ヶー 　]+"
                  required
                  :error="getFieldError('companyKanaName')"
                />
              </m-form-input>
              <m-form-input label="郵便番号">
                <!-- <a-text-field v-model="formData.companyPostCode" /> -->
                <a-text-field
                  id="companyPostCode"
                  v-model="formData.companyPostCode"
                  type="text"
                  placeholder="ハイフンなし"
                  maxlength="7"
                  pattern="[0-9]{7}"
                  required
                  :error="getFieldError('companyPostCode')"
                />
              </m-form-input>
              <m-form-input label="都道府県名 *">
                <!-- <a-text-field v-model="formData.companyAddress1" /> -->
                <a-select-field
                  id="companyAddress1"
                  v-model="formData.companyAddress1"
                  :options="prefectures"
                  required
                  :error="getFieldError('companyAddress1')"
                />
              </m-form-input>
              <m-form-input label="市区町村 *">
                <!-- <a-text-field v-model="formData.companyAddress2" /> -->
                <a-text-field
                  id="companyAddress2"
                  v-model="formData.companyAddress2"
                  type="text"
                  placeholder="入力してください"
                  maxlength="20"
                  required
                  :error="getFieldError('companyAddress2')"
                />
              </m-form-input>
              <m-form-input label="字丁目番地など *">
                <!-- <a-text-field v-model="formData.companyAddress3" /> -->
                <a-text-field
                  id="companyAddress3"
                  v-model="formData.companyAddress3"
                  type="text"
                  placeholder="入力してください"
                  maxlength="20"
                  required
                  :error="getFieldError('companyAddress3')"
                />
              </m-form-input>
              <m-form-input label="住所建物など *">
                <!-- <a-text-field v-model="formData.companyAddress4" /> -->
                <a-text-field
                  id="companyAddress4"
                  v-model="formData.companyAddress4"
                  type="text"
                  placeholder="変更があれば入力してください"
                  maxlength="20"
                />
              </m-form-input>
              <m-form-input label="事業内容 *">
                <a-text-field
                  id="companyBusinessDetails"
                  v-model="formData.companyBusinessDetails"
                  type="text"
                  placeholder="入力してください"
                  maxlength="100"
                />
              </m-form-input>
              <m-form-input label="実質的支配者の有無">
                <a-radio
                  id="companyRulerFlagOff"
                  v-model="radio"
                  name="flag"
                  value="false"
                  label="無"
                  :error="getFieldError('companyRulerFlag')"
                />
                <a-radio
                  id="companyRulerFlagOn"
                  v-model="radio"
                  name="flag"
                  value="true"
                  label="有"
                  :error="getFieldError('companyRulerFlag')"
                />
              </m-form-input>

              <template v-if="companyRulerFlag">
                <m-form-input label="実質的支配者名">
                  <a-text-field
                    id="companyRulerName"
                    v-model="formData.companyRulerName"
                    type="text"
                    placeholder=""
                    maxlength="40"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者住所">
                  <a-text-field
                    id="companyRulerAddress"
                    v-model="formData.companyRulerAddress"
                    type="text"
                    placeholder=""
                    maxlength="80"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者生年月日">
                  <a-text-field
                    id="companyRulerBirthDateView"
                    v-model="formData.companyRulerBirthDateView"
                    type="text"
                    placeholder="YYYYMMDD"
                    maxlength="8"
                    pattern="[0-9]{8}"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者の法人との関係">
                  <a-text-field
                    id="companyRelationship"
                    v-model="formData.companyRelationship"
                    type="text"
                    placeholder=""
                    maxlength="20"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者名2">
                  <a-text-field
                    id="companyRulerName2"
                    v-model="formData.companyRulerName2"
                    type="text"
                    placeholder=""
                    maxlength="40"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者住所2">
                  <a-text-field
                    id="companyRulerAddress2"
                    v-model="formData.companyRulerAddress2"
                    type="text"
                    placeholder=""
                    maxlength="80"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者生年月日2">
                  <a-text-field
                    id="companyRulerBirthDateView2"
                    v-model="formData.companyRulerBirthDateView2"
                    type="text"
                    placeholder="YYYYMMDD"
                    maxlength="8"
                    pattern="[0-9]{8}"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者の法人との関係2">
                  <a-text-field
                    id="companyRelationship2"
                    v-model="formData.companyRelationship2"
                    type="text"
                    placeholder=""
                    maxlength="20"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者名3">
                  <a-text-field
                    id="companyRulerName3"
                    v-model="formData.companyRulerName3"
                    type="text"
                    placeholder=""
                    maxlength="40"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者住所3">
                  <a-text-field
                    id="companyRulerAddress3"
                    v-model="formData.companyRulerAddress3"
                    type="text"
                    placeholder=""
                    maxlength="80"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者生年月日3">
                  <a-text-field
                    id="companyRulerBirthDateView3"
                    v-model="formData.companyRulerBirthDateView3"
                    type="text"
                    placeholder="YYYYMMDD"
                    maxlength="8"
                    pattern="[0-9]{8}"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者の法人との関係3">
                  <a-text-field
                    id="companyRelationship3"
                    v-model="formData.companyRelationship3"
                    type="text"
                    placeholder=""
                    maxlength="20"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者名4">
                  <a-text-field
                    id="companyRulerName4"
                    v-model="formData.companyRulerName4"
                    type="text"
                    placeholder=""
                    maxlength="40"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者住所4">
                  <a-text-field
                    id="companyRulerAddress4"
                    v-model="formData.companyRulerAddress4"
                    type="text"
                    placeholder=""
                    maxlength="80"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者生年月日4">
                  <a-text-field
                    id="companyRulerBirthDateView4"
                    v-model="formData.companyRulerBirthDateView4"
                    type="text"
                    placeholder="YYYYMMDD"
                    maxlength="8"
                    pattern="[0-9]{8}"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
                <m-form-input label="実質的支配者の法人との関係4">
                  <a-text-field
                    id="companyRelationship4"
                    v-model="formData.companyRelationship4"
                    type="text"
                    placeholder=""
                    maxlength="20"
                    :disabled="!companyRulerFlag"
                  />
                </m-form-input>
              </template>
            </template>
            <!-- <m-form-input label="メールアドレス">
              <a-text-field v-model="formData.email" :disabled="true" />
            </m-form-input> -->

            <p>請求書送付先</p>
            <m-form-input label="郵便番号 *">
              <a-text-field
                id="invoicePostCode"
                v-model="formData.invoicePostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                required
                :error="getFieldError('invoicePostCode')"
              />
            </m-form-input>
            <m-form-input label="都道府県名 *">
              <a-select-field
                id="invoiceAddress1"
                v-model="formData.invoiceAddress1"
                :options="prefectures"
                required
                :error="getFieldError('invoiceAddress1')"
              />
            </m-form-input>
            <m-form-input label="市区町村 *">
              <a-text-field
                id="invoiceAddress2"
                v-model="formData.invoiceAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('invoiceAddress2')"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など *">
              <a-text-field
                id="invoiceAddress3"
                v-model="formData.invoiceAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('invoiceAddress3')"
              />
            </m-form-input>
            <m-form-input label="住所建物など *">
              <a-text-field
                id="invoiceAddress4"
                v-model="formData.invoiceAddress4"
                type="text"
                placeholder="変更があれば入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="送付先名 *">
              <a-text-field
                id="invoiceName"
                v-model="formData.invoiceName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :error="getFieldError('invoiceName')"
              />
            </m-form-input>
            <m-form-input label="送付先名カナ *">
              <a-text-field
                id="invoiceKanaName"
                v-model="formData.invoiceKanaName"
                type="text"
                placeholder="入力してください"
                maxlength="35"
              />
            </m-form-input>
            <m-form-input label="電話番号 *">
              <a-text-field
                id="invoicePhoneNumber"
                v-model="formData.invoicePhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :error="getFieldError('invoicePhoneNumber')"
              />
            </m-form-input>

            <template v-if="uploadFlag1 || uploadFlag2">
              <m-action-card
                class="t-contract-edit-contractor-info__field-options"
                title="本人確認書類　画像アップロード"
                :border="true"
                :header-border="true"
              >
                <a-caption-list>
                  <!-- <li>名前、法人名、住所を変更する際に必要です。</li> -->
                  <li>必ずカラーでアップロードしてください。</li>
                </a-caption-list>

                <template v-if="uploadFlag1">
                  <template v-for="(document, index) in formDataUpload.documents" :key="index">
                    <m-form-input label="本人確認書類(画像ファイル)">
                      <a-select-field
                        id="documentType"
                        v-model="document.type"
                        placeholder="書類の種類を選択してください"
                        :options="documentTypeOptions"
                        @change="handleChange"
                      />
                      <div class="t-contract-edit-contractor-info__field-uploads">
                        <div
                          v-for="(image, imageIndex) in document.images"
                          :key="imageIndex"
                          class="t-contract-edit-contractor-info__field-uploads-col"
                        >
                          <a-upload-field
                            :id="'imgbox_' + imageIndex"
                            v-model="image.file"
                            label="ファイルをドラッグ＆ドロップするか
パソコンからアップロード
してください。

※対応するファイル形式は
.jpeg .jpg .png .pdfです。"
                            accept="image/*, application/pdf"
                            @change="handleUploadFileChange1(index, imageIndex, image.file)"
                          />
                        </div>
                      </div>
                      <a-select-field
                        v-if="formData.businessType === 'individual'"
                        id="-uploadType2"
                        v-model="document.type2"
                        placeholder="書類の種類を選択してください"
                        :options="documentTypeOptions2"
                        @change="handleChange2"
                      />
                      <div
                        v-if="formData.businessType === 'individual'"
                        class="t-contract-edit-contractor-info__field-uploads"
                      >
                        <div
                          v-for="(image2, imageIndex) in document.images2"
                          :id="'imgbox02_' + imageIndex"
                          :key="imageIndex"
                          class="t-contract-edit-contractor-info__field-uploads-col"
                        >
                          <a-upload-field
                            v-model="image2.file"
                            label="ファイルをドラッグ＆ドロップするか
パソコンからアップロード
してください。

※対応するファイル形式は
.jpeg .jpg .png .pdfです。"
                            accept="image/*, application/pdf"
                            @change="handleUploadFileChange1(index, imageIndex + 2, image2.file)"
                          />
                        </div>
                      </div>
                    </m-form-input>
                  </template>
                </template>

                <template v-if="uploadFlag2">
                  <div class="m-form-input">
                    <label class="m-form-input__label">登記事項証明書（登記簿謄本）(PDF、最大10枚)</label>
                  </div>
                  <template v-for="(document, index) in formDataUpload.documents2" :key="index">
                    <div class="t-contract-edit-contractor-info__field-uploads">
                      <div
                        v-for="(image, imageIndex) in document.images"
                        :key="imageIndex"
                        class="t-contract-edit-contractor-info__field-uploads-col"
                      >
                        <a-upload-field
                          :id="'imgbox2_' + (index * 2 + imageIndex)"
                          v-model="image.file"
                          label="ファイルをドラッグ＆ドロップするかパソコンから画像を貼り付けしてください。"
                          accept="application/pdf"
                          @change="handleUploadFileChange2(index, imageIndex, image.file)"
                        />
                      </div>
                    </div>
                  </template>
                </template>
                <template v-if="formData.businessType === 'company' && uploadFlag3">
                  <div class="m-form-input">
                    <label class="m-form-input__label">委任状(PDF、最大1枚)</label>
                  </div>
                  <template v-for="(document, index) in formDataUpload.documents3" :key="index">
                    <div class="t-contract-edit-contractor-info__field-uploads">
                      <div
                        v-for="(image, imageIndex) in document.images"
                        :key="imageIndex"
                        class="t-contract-edit-contractor-info__field-uploads-col"
                      >
                        <a-upload-field
                          :id="'imgbox3_' + imageIndex"
                          v-model="image.file"
                          label="ファイルをドラッグ＆ドロップするかパソコンから画像を貼り付けしてください。"
                          accept="application/pdf"
                          @change="handleUploadFileChange3(index, imageIndex, image.file)"
                        />
                      </div>
                    </div>
                  </template>
                </template>
              </m-action-card>
            </template>
            <m-form-action-buttons>
              <!-- <a-button variant="block" color="primary" submit="submit" :disabled="disableFlag">保存</a-button>
              <a-button variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button> -->
              <a-button
                id="apply"
                variant="block"
                color="primary"
                submit="submit"
                :disabled="disableFlag || !flagAplyButtonEnable"
                >変更を申請</a-button
              >
              <a-button id="back" variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="ContractEditContractorInfo_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="ContractEditContractorInfo_confirmModal"
      v-model:visible="confirmModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ confirmModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="confirmModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="profileModalCloseButton"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          id="profileModalYesButton"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleUpdateEmail"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="ContractEditContractorInfo_confirmModal2"
      v-model:visible="confirmModalVisible2"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ confirmModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="confirmModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="profileModalCloseButton"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          id="profileModalYesButton"
          variant="block"
          color="primary"
          label="変更を申請"
          size="small"
          @click="handleUpdateEmail"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ACaptionList from '@/components/atoms/caption-list';
import ASelectField from '@/components/atoms/select-field';
import ATextField from '@/components/atoms/text-field';
import AUploadField from '@/components/atoms/upload-field';
import { cloneDeep } from 'lodash';
import { IDENTIFICATION_OPTIONS, IDENTIFICATION_OPTIONS2 } from '@/libs/constants';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PREFECTURES } from '@/libs/constants';
import { POINT } from '@/libs/constants';
import { JOBS } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

// For Trial
import { utils } from '@/common/utils.js';

import Loading from 'vue-loading-overlay';
import dayjs from 'dayjs';

export default {
  name: 't-contract-edit-contractor-info',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    AButton,
    MFormInput,
    ACaptionList,
    ASelectField,
    ATextField,
    AUploadField,
    Loading,
  },
  mixins: [customRequest, messageContent, customValidate], // #2456

  props: {
    class: {
      type: String,
      default: '',
    },
    // currentData: {
    //   type: Object,
    //   default: null,
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    handleSaveClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      confirmModalTitle: '',
      confirmModalContent: '',
      confirmModalVisible: false,
      confirmModalVisible2: false,
      documentTypeOptions: IDENTIFICATION_OPTIONS,
      documentTypeOptionsBase: IDENTIFICATION_OPTIONS2,
      documentTypeOptions2: IDENTIFICATION_OPTIONS2,
      formData: {
        lastname: '',
        name: '',
        lastname_kana: '',
        name_kana: '',
        adminBirthDate: '',
        adminPhoneNumber: '',
        adminEmail: '',
        adminPostCode: '',
        adminAddress1: '',
        adminAddress2: '',
        adminAddress3: '',
        adminAddress4: '',
        companyName: '',
        companyKanaName: '',
        companyPostCode: '',
        companyAddress1: '',
        companyAddress2: '',
        companyAddress3: '',
        companyAddress4: '',
        soStatus: 'review',
        businessType: 'individual',
        // adminBirthDate: '',
        // adminDepartment: '',
        adminJob: '',
        // adminKanaName: '',
        // adminName: '',
        // billType: '',
        // companyBusinessDetails: '',
        // companyRelationship: '',
        // companyRulerAddress: '',
        // companyRulerBirthDate: '',
        // companyRulerName: '',
        companyRulerFlag: false,
        invoiceAddress1: '', // #2195
        invoiceAddress2: '', // #2195
        invoiceAddress3: '', // #2195
        invoiceAddress4: '', // #2195
        //invoiceDepartment: '',  // #2195
        invoiceName: '', // #2195
        invoiceKanaName: '',
        invoicePhoneNumber: '', // #2195
        invoicePostCode: '', // #2195
        // note: '',
        // openDay: null,
        // purposeOfUse: '',
        // responderName: '',
        // voicedxOnlyFlag: false,
        // contractStatus: '',
      },
      formOrgData: {},
      formDataUpload: {
        documents: [
          {
            type: null,
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
            images2: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
        documents2: [
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
          {
            type: 'toukijikou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
        documents3: [
          {
            type: 'inninjou',
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
      },
      uploadFlag1: false,
      uploadFlag2: false,
      uploadFlag3: false,
      chkDiff: false,
      contractStatusFlag: false,
      soStatusFlag: false,
      disableFlag: true,
      selectedCompanyID: '',
      companyIDList: [],
      prefectures: [],
      POINT,
      birthFrom: '',
      birthTo: '',
      flagAplyButtonEnable: true, //#1892
      authInfo: this.$store.state.user.authInfo, // #2328
      // #2456 特殊記号チェック対象項目のリスト(契約者情報・請求書送付先)
      spCharCheckList: [
        {
          name: '契約者情報.氏名',
          fieldName: 'lastname',
        },
        {
          name: '契約者情報.氏名',
          fieldName: 'name',
        },
        {
          name: '契約者情報.氏名カナ',
          fieldName: 'lastname_kana',
        },
        {
          name: '契約者情報.氏名カナ',
          fieldName: 'name_kana',
        },
        {
          name: '契約者情報.電話番号',
          fieldName: 'adminPhoneNumber',
        },
        {
          name: '契約者情報.職業',
          fieldName: 'adminJob',
        },
        {
          name: '契約者情報.メールアドレス',
          fieldName: 'adminEmail',
        },
        {
          name: '契約者情報.郵便番号',
          fieldName: 'adminPostCode',
        },
        {
          name: '契約者情報.市区町村',
          fieldName: 'adminAddress2',
        },
        {
          name: '契約者情報.字丁目番地など',
          fieldName: 'adminAddress3',
        },
        {
          name: '契約者情報.住所建物など',
          fieldName: 'adminAddress4',
        },
        {
          name: '契約者情報.利用目的',
          fieldName: 'purposeOfUse',
        },
        {
          name: '請求書送付先.郵便番号',
          fieldName: 'invoicePostCode',
        },
        {
          name: '請求書送付先.市区町村',
          fieldName: 'invoiceAddress2',
        },
        {
          name: '請求書送付先.字丁目番地など',
          fieldName: 'invoiceAddress3',
        },
        {
          name: '請求書送付先.住所建物など',
          fieldName: 'invoiceAddress4',
        },
        {
          name: '請求書送付先.送付先名',
          fieldName: 'invoiceName',
        },
        {
          name: '請求書送付先.送付先名カナ',
          fieldName: 'invoiceKanaName',
        },
        {
          name: '請求書送付先.電話番号',
          fieldName: 'invoicePhoneNumber',
        },
      ],
      // #2456 特殊記号チェック対象項目のリスト(法人情報)
      spCharCheckListCompany: [
        {
          name: '法人情報.契約名義',
          fieldName: 'companyName',
        },
        {
          name: '法人情報.契約名義カナ',
          fieldName: 'companyKanaName',
        },
        {
          name: '法人情報.郵便番号',
          fieldName: 'companyPostCode',
        },
        {
          name: '法人情報.市区町村',
          fieldName: 'companyAddress2',
        },
        {
          name: '法人情報.字丁目番地など',
          fieldName: 'companyAddress3',
        },
        {
          name: '法人情報.住所建物など',
          fieldName: 'companyAddress4',
        },
        {
          name: '法人情報.事業内容',
          fieldName: 'companyBusinessDetails',
        },
      ],
      // #3173
      spCharCheckListRuler: [
        {
          name: '法人情報.実質的支配者名',
          fieldName: 'companyRulerName',
        },
        {
          name: '法人情報.実質的支配者住所',
          fieldName: 'companyRulerAddress',
        },
        {
          name: '法人情報.実質的支配者生年月日',
          fieldName: 'companyRulerBirthDate',
        },
        {
          name: '法人情報.実質的支配者の法人との関係',
          fieldName: 'companyRelationship',
        },
        {
          name: '法人情報.実質的支配者名2',
          fieldName: 'companyRulerName2',
        },
        {
          name: '法人情報.実質的支配者住所2',
          fieldName: 'companyRulerAddress2',
        },
        {
          name: '法人情報.実質的支配者生年月日2',
          fieldName: 'companyRulerBirthDateView2',
        },
        {
          name: '法人情報.実質的支配者の法人との関係2',
          fieldName: 'companyRelationship2',
        },
        {
          name: '法人情報.実質的支配者名3',
          fieldName: 'companyRulerName3',
        },
        {
          name: '法人情報.実質的支配者住所3',
          fieldName: 'companyRulerAddress3',
        },
        {
          name: '法人情報.実質的支配者生年月日3',
          fieldName: 'companyRulerBirthDateView3',
        },
        {
          name: '法人情報.実質的支配者の法人との関係3',
          fieldName: 'companyRelationship3',
        },
        {
          name: '法人情報.実質的支配者名4',
          fieldName: 'companyRulerName4',
        },
        {
          name: '法人情報.実質的支配者住所4',
          fieldName: 'companyRulerAddress4',
        },
        {
          name: '法人情報.実質的支配者生年月日4',
          fieldName: 'companyRulerBirthDateView4',
        },
        {
          name: '法人情報.実質的支配者の法人との関係4',
          fieldName: 'companyRelationship4',
        },
      ],
      radio: false,
      companyRulerFlag: false,
      isLoading: false,
      companyRuler: [],
      jobs: [],
      adminEmail: '',
      location: false,
      certificateCollectionURL: {
        MyNumber: 'my_number_card',
        Driverlicense1: 'driver_license',
        Driverlicense2: 'driver_license',
        DrivingHistory1: 'driving_history',
        DrivingHistory2: 'driving_history',
        SealRegistration: 'seal_registration',
        FamilyRegister: 'family_register',
        CertificateOfResidence: 'Certificate_of_residence',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-contractor-info');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  // watch: {
  //   currentData(val) {
  //     this.setFormData(val);
  //   },
  // },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        // 連続に2回ルーターpushするのを禁止する #2427
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }

        if (!utils.chkTrialCompanyID(this.companyID)) {
          this.fetchContractDataHandler();
          this.checkSoStatus();
        }
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
  },
  created() {
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    // #2328
    let invalidFlag = false;
    // soOperatorはメニューではねている=改竄されている
    if (this.authInfo === 'soOperator') {
      invalidFlag = true;
    }
    // POINT以外でログインした企業ID以外が指定されてきた=企業IDが改竄されている
    if (this.companyID !== POINT && this.selectedCompanyID !== this.companyID) {
      invalidFlag = true;
    }
    // POINT以外でかつ権限が(manager||operator)=メニューではねられるはずなので改竄疑い
    if (this.companyID !== POINT && (this.authInfo === 'manager' || this.authInfo === 'operator')) {
      invalidFlag = true;
    }
    // ログインがPOINTかつPOINT選択はsupervisor以外できないはず=改竄疑い
    if (
      this.companyID === POINT &&
      this.selectedCompanyID === POINT &&
      (this.authInfo === 'manager' || this.authInfo === 'operator')
    ) {
      invalidFlag = true;
    }
    // For Trial
    if (
      utils.chkTrialCompanyID(this.companyID) ||
      (this.companyID === POINT && utils.chkTrialCompanyID(this.selectedCompanyID))
    ) {
      invalidFlag = true;
    }
    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }

    if (this.companyID === POINT) {
      this.fetchCompanyIDListHandler();
    }
    this.prefectures = PREFECTURES;
    this.jobs = JOBS;

    const setDate = dayjs();
    const year = setDate.format('YYYY');
    const month = setDate.format('MM');
    const date = setDate.format('DD');

    this.birthFrom = year - 100 + '-01-01';
    this.birthTo = year + '-' + month + '-' + date;
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.confirmModalVisible = false;
      this.confirmModalVisible2 = false;
      this.confirmModalTitle = '';
      this.confirmModalContent = '';
      if (this.location) {
        window.location.href = '/contract?companyID=' + this.selectedCompanyID;
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    // setFormData(data) {
    //   this.formData.name = data.name || '';
    //   this.formData.company_name = data.company_name || '';
    //   this.formData.phone_number = data.phone_number || '';
    //   this.formData.street_address = data.street_address || '';
    //   this.formData.post_code = data.post_code || '';
    //   this.formData.email = data.email || '';
    //   // set documents if any
    //   if (data.documents) {
    //     data.documents.forEach((document, documentIndex) => {
    //       if (document.type && documentIndex < this.formData.documents.length - 1) {
    //         const formDocument = this.formData.documents[documentIndex];
    //         formDocument.type = document.type;
    //         if (document.images) {
    //           document.images.forEach((image, imageIndex) => {
    //             if (image.file && imageIndex < formDocument.images.length - 1) {
    //               formDocument.images[imageIndex].file = image.file;
    //             }
    //           });
    //         }
    //       }
    //     });
    //   }
    // },
    getFieldError(key) {
      if (key === 'companyRulerFlag') {
        if (this.radio === 'true') {
          this.companyRulerFlag = true;
        } else if (this.radio === 'false') {
          this.companyRulerFlag = false;
        }
      }

      // 本人確認書類のアップロードの項目表示処理
      this.uploadFlag1 = false;
      this.uploadFlag3 = false;
      const indivisual = [
        'lastname',
        'name',
        'adminBirthDate',
        'adminAddress1',
        'adminAddress2',
        'adminAddress3',
        'adminAddress4',
      ];
      for (let i = 0; i < indivisual.length; i++) {
        if (this.formData[indivisual[i]] !== this.formOrgData[indivisual[i]]) {
          this.uploadFlag1 = true;
          if (indivisual[i] !== 'adminBirthDate') {
            this.uploadFlag3 = true;
          }
        }
      }

      // 法人のアップロードの項目表示処理
      this.uploadFlag2 = false;
      const company = [
        'companyName',
        'companyAddress1',
        'companyAddress2',
        'companyAddress3',
        'companyAddress4',
        'companyBusinessDetails',
      ];
      for (let i = 0; i < company.length; i++) {
        if (this.formData[company[i]] !== this.formOrgData[company[i]]) {
          this.uploadFlag2 = true;
          if (company[i] !== 'companyBusinessDetails') {
            this.uploadFlag3 = true;
          }
        }
      }

      // 変更を申請ボタンの活性化処理
      // 差分チェック用
      const arrInput1 = [
        'lastname',
        'name',
        'lastname_kana',
        'name_kana',
        'adminBirthDate',
        'adminEmail',
        'adminJob',
        'adminPhoneNumber',
        'adminPostCode',
        'adminAddress1',
        'adminAddress2',
        'adminAddress3',
        'adminAddress4',
        'purposeOfUse',
        'invoicePostCode', // #2195
        'invoiceAddress1', // #2195
        'invoiceAddress2', // #2195
        'invoiceAddress3', // #2195
        'invoiceAddress4', // #2195
        'invoiceName', // #2195
        'invoiceKanaName',
        'invoicePhoneNumber', // #2195
      ];
      // 未入力チェック用
      const arrInput2 = [
        'lastname',
        'name',
        'lastname_kana',
        'name_kana',
        'adminBirthDate',
        'adminEmail',
        'adminPhoneNumber',
        'adminPostCode',
        'adminAddress1',
        'adminAddress2',
        'adminAddress3',
        'invoicePostCode', // #2195
        'invoiceAddress1', // #2195
        'invoiceAddress2', // #2195
        'invoiceAddress3', // #2195
        'invoiceName', // #2195
        'invoicePhoneNumber', // #4513
      ];

      if (this.formData.businessType === 'company') {
        arrInput1.push('companyName');
        arrInput1.push('companyKanaName');
        arrInput1.push('companyPostCode');
        arrInput1.push('companyAddress1');
        arrInput1.push('companyAddress2');
        arrInput1.push('companyAddress3');
        arrInput1.push('companyAddress4');
        arrInput1.push('companyBusinessDetails');

        arrInput2.push('companyName');
        arrInput2.push('companyKanaName');
        arrInput2.push('companyPostCode');
        arrInput2.push('companyAddress1');
        arrInput2.push('companyAddress2');
        arrInput2.push('companyAddress3');
      }

      if (this.radio === 'true') {
        let companyRulerNo = '';
        const arrInput = [
          'companyRulerName',
          'companyRulerAddress',
          'companyRulerBirthDateView',
          'companyRelationship',
        ];
        for (let i = 0; i < 4; i++) {
          if (i > 0) {
            companyRulerNo = String(i + 1);
          }

          for (let j = 0; j < arrInput.length; j++) {
            arrInput1.push(arrInput[j] + companyRulerNo);
          }
        }
      }

      // 「*」入力項目の差分チェック
      this.chkDiff = false;
      const arrInput3 = [
        'lastname',
        'name',
        'adminBirthDate',
        'adminAddress1',
        'adminAddress2',
        'adminAddress3',
        'adminAddress4',
        'invoicePostCode',
        'invoiceAddress1',
        'invoiceAddress2',
        'invoiceAddress3',
        'invoiceAddress4',
        'invoiceName',
        'invoiceKanaName',
        'invoicePhoneNumber',
        'companyName',
        'companyAddress1',
        'companyAddress2',
        'companyAddress3',
        'companyAddress4',
        'companyBusinessDetails',
      ];
      for (let i = 0; i < arrInput3.length; i++) {
        if (this.formData[arrInput3[i]] !== this.formOrgData[arrInput3[i]]) {
          this.chkDiff = true;
          break;
        }
      }

      // 差分チェック
      let tmpFlag1 = true;
      for (let i = 0; i < arrInput1.length; i++) {
        if (this.formData[arrInput1[i]] !== this.formOrgData[arrInput1[i]]) {
          tmpFlag1 = false;
          break;
        }
      }

      if (this.formData.companyRulerFlag !== this.companyRulerFlag) {
        tmpFlag1 = false;
      }

      // 未入力チェック
      let tmpFlag2 = false;
      for (let i = 0; i < arrInput2.length; i++) {
        if (this.formData[arrInput2[i]] === '') {
          tmpFlag2 = true;
          break;
        }
      }

      // ボタンの活性化チェック
      this.disableFlag = false;
      if (tmpFlag1 || tmpFlag2 || this.contractStatusFlag || this.soStatusFlag) {
        this.disableFlag = true;
      }
    },
    handleChange() {
      const type = this.formDataUpload.documents[0].type;

      document.getElementById('imgbox_0').style.display = 'block';
      document.getElementById('imgbox_1').style.display = 'block';
      if (type === 'my_number_card') {
        document.getElementById('imgbox_1').style.display = 'none';
      }

      const documentTypeOptionsBase = cloneDeep(this.documentTypeOptionsBase);
      this.documentTypeOptions2 = documentTypeOptionsBase;
      for (const key in this.documentTypeOptions2) {
        if (this.documentTypeOptions2[key].value === type) {
          if (type === this.formDataUpload.documents[0].type2) {
            this.formDataUpload.documents[0].type2 = undefined;
          }
          this.documentTypeOptions2.splice(key, 1);
          break;
        }
      }
    },
    handleChange2() {
      const type = this.formDataUpload.documents[0].type;
      const type2 = this.formDataUpload.documents[0].type2;

      document.getElementById('imgbox02_0').style.display = 'block';
      document.getElementById('imgbox02_1').style.display = 'block';
      if (type2 !== 'driver_license' && type2 !== 'driving_history') {
        document.getElementById('imgbox02_1').style.display = 'none';
      }
    },
    async handleFormSubmit(e) {
      this.flagAplyButtonEnable = false; //#1892
      this.adminEmail = this.formOrgData.adminEmail;
      if (this.formOrgData.adminEmail !== this.formData.adminEmail) {
        // 契約メールアドレスの変更があった場合、確認モーダル画面を表示
        this.showConfirmModal(messageContent.confirmForceUpdateAdminEmail(this.formData.adminEmail));
      } else if (this.chkDiff) {
        // *がついている内容を含む申請があった場合
        this.showConfirmModal2(messageContent.alertChangeApplication());
      } else {
        await this.handleFormSubmit2(e);
      }
      this.flagAplyButtonEnable = true; //#1892
    },
    handleFormSubmit2: async function (e) {
      const constractStatusResult = await this.checkContractStatus();
      if (!constractStatusResult) {
        return;
      }

      const soStatusResult = await this.checkSoStatus();
      if (!soStatusResult) {
        return;
      }

      e.preventDefault();
      const payload = cloneDeep(this.formData);
      const payload2 = {
        certificateType: '',
        certificateType2: '',
        DriverlicenseURL1: '',
        DriverlicenseURL2: '',
        MyNumberURL: '',
        DrivingHistoryURL1: '',
        DrivingHistoryURL2: '',
        SealRegistrationURL: '',
        FamilyRegisterURL: '',
        CertificateOfResidenceURL: '',
        copyOfCompanyRegisterURL1: '',
        copyOfCompanyRegisterURL2: '',
        copyOfCompanyRegisterURL3: '',
        copyOfCompanyRegisterURL4: '',
        copyOfCompanyRegisterURL5: '',
        copyOfCompanyRegisterURL6: '',
        copyOfCompanyRegisterURL7: '',
        copyOfCompanyRegisterURL8: '',
        copyOfCompanyRegisterURL9: '',
        copyOfCompanyRegisterURL10: '',
        letterOfAttorneyURL: '',
      };
      const payload3 = cloneDeep(this.formDataUpload);
      // this.handleSaveClick(payload);

      try {
        // #2456 特殊記号チェックを追加
        for (const item of this.spCharCheckList) {
          if (this.hasSpecialCharacterInObject({ keyWord: payload[item.fieldName].replace(/\r?\n/g, '') })) {
            this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
            return;
          }
        }
        if (this.formData.businessType === 'company') {
          for (const item of this.spCharCheckListCompany) {
            if (this.hasSpecialCharacterInObject({ keyWord: payload[item.fieldName] })) {
              this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
              return;
            }
          }
          if (this.radio === 'true') {
            const itemName = this.chkSpecialCharacter(payload);
            if (itemName !== '') {
              this.showErrorModal(messageContent.requireNotSpecialCharacter(itemName));
              return;
            }
          }
        }

        // #3679 '_'接続処理はBE側へ移行
        /*
        // 入力フォームの情報からFireStore用のデータ形式を生成
        payload.adminName = payload.lastname + '_' + payload.name;
        payload.adminKanaName = payload.lastname_kana + '_' + payload.name_kana;
        */

        let setAdminBirthDate = '';
        if (payload.adminBirthDate.length === 8) {
          const y = payload.adminBirthDate.substr(0, 4);
          const m = payload.adminBirthDate.substr(4, 2);
          const d = payload.adminBirthDate.substr(6);
          setAdminBirthDate = y + '-' + m + '-' + d;
        }
        payload.adminBirthDate = setAdminBirthDate;

        // 職業を変換して値セット
        const found = this.jobs.find(element => element.label === payload.adminJob);
        if (typeof found !== 'undefined') {
          payload.adminJob = found.value;
          this.formOrgData.adminJob = payload.adminJob;
        }

        payload.companyRulerFlag = this.companyRulerFlag;
        let companyRulerNo = '';
        for (let j = 0; j < 4; j++) {
          if (j > 0) {
            companyRulerNo = String(j + 1);
          }

          if (this.companyRulerFlag === true) {
            let setCompanyRulerBirthDate = '';
            if (payload['companyRulerBirthDateView' + companyRulerNo].length === 8) {
              const y = payload['companyRulerBirthDateView' + companyRulerNo].substr(0, 4);
              const m = payload['companyRulerBirthDateView' + companyRulerNo].substr(4, 2);
              const d = payload['companyRulerBirthDateView' + companyRulerNo].substr(6);
              setCompanyRulerBirthDate = y + '-' + m + '-' + d;
            }
            payload['companyRulerBirthDate' + companyRulerNo] = setCompanyRulerBirthDate;
          } else {
            payload['companyRulerName' + companyRulerNo] = '';
            payload['companyRulerAddress' + companyRulerNo] = '';
            payload['companyRulerBirthDate' + companyRulerNo] = '';
            payload['companyRelationship' + companyRulerNo] = '';
          }
        }

        if (typeof payload.purposeOfUse !== 'undefined') {
          payload.purposeOfUse = payload.purposeOfUse.replace(/\n/g, '%%n%%');
        }

        // 入力項目のバリデーションチェック
        const validateResult1 = await this.validateParamIndividual(payload);
        if (!validateResult1) {
          return;
        }

        if (payload.businessType === 'company') {
          const validateResult2 = await this.validateParamHoujin(payload);
          if (!validateResult2) {
            return;
          }
        }

        if (this.uploadFlag1) {
          // 本人確認書類のチェック
          if (!payload3.documents[0].images[0].binary && !payload3.documents[0].images[1].binary) {
            this.showErrorModal(messageContent.requireUploadFile('本人確認書類'));
            return;
          }

          const type = payload3.documents[0].type;
          const type2 = payload3.documents[0].type2;
          if (type === IDENTIFICATION_OPTIONS[0].value) {
            // console.log('運転免許証');
            if (!payload3.documents[0].images[0].binary || !payload3.documents[0].images[1].binary) {
              this.showErrorModal(messageContent.alertDriverLicense('運転免許証'));
              return;
            }
          } else if (type === IDENTIFICATION_OPTIONS[1].value) {
            payload3.documents[0].images[1].label = null;
            payload3.documents[0].images[1].size = null;
            payload3.documents[0].images[1].binary = null;
            payload3.documents[0].images[1].filename = null;

            // console.log('マイナンバー');
            if (!payload3.documents[0].images[0].binary) {
              this.showErrorModal(messageContent.alertIdentification('マイナンバー'));
              return;
            }
          } else {
            this.showErrorModal(messageContent.requireChoice('書類の種類'));
            return;
          }

          if (payload.businessType === 'individual') {
            const matchNo = Object.keys(IDENTIFICATION_OPTIONS2).find(
              key => IDENTIFICATION_OPTIONS2[key].value === type2
            );

            if (typeof matchNo === 'undefined') {
              this.showErrorModal(messageContent.requireChoice('書類の種類'));
              return;
            }

            if (matchNo === '0' || matchNo === '2') {
              if (
                payload3.documents[0].images2[0].binary === null ||
                payload3.documents[0].images2[1].binary === null
              ) {
                this.showErrorModal(messageContent.alertDriverLicense(IDENTIFICATION_OPTIONS2[matchNo].label));
                return;
              }
            } else {
              payload3.documents[0].images2[1].label = null;
              payload3.documents[0].images2[1].size = null;
              payload3.documents[0].images2[1].binary = null;
              payload3.documents[0].images2[1].filename = null;
              if (payload3.documents[0].images2[0].binary === null) {
                this.showErrorModal(
                  messageContent.alertIdentification(IDENTIFICATION_OPTIONS2[matchNo].label.replace('(表のみ1枚)', ''))
                );
                return;
              }
            }
          }
        }

        if (payload.businessType === 'company' && this.uploadFlag2 === true) {
          // 登記事項証明書のチェック
          if (
            !payload3.documents2[0].images[0].binary &&
            !payload3.documents2[0].images[1].binary &&
            !payload3.documents2[1].images[0].binary &&
            !payload3.documents2[1].images[1].binary &&
            !payload3.documents2[2].images[0].binary &&
            !payload3.documents2[2].images[1].binary &&
            !payload3.documents2[3].images[0].binary &&
            !payload3.documents2[3].images[1].binary &&
            !payload3.documents2[4].images[0].binary &&
            !payload3.documents2[4].images[1].binary
          ) {
            this.showErrorModal(messageContent.requireUploadFile('登記事項証明書（登記簿謄本）'));
            return;
          }
        }

        if (payload.businessType === 'company' && this.uploadFlag3 === true) {
          // 登記事項証明書のチェック
          if (!payload3.documents3[0].images[0].binary) {
            this.showErrorModal(messageContent.requireUploadFile('委任状(PDF、最大1枚)'));
            return;
          }
        }

        // ファイルサイズチェック
        for (let j = 0; j < 2; j++) {
          if (payload3.documents[0].images[j].size !== null && payload3.documents[0].images[j].size > 10485760) {
            this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
            return;
          }
          if (payload3.documents[0].images[j].filename !== null) {
            if (payload3.documents[0].images[j].filename.length > 100) {
              this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
              return;
            }
          }
        }
        for (let j = 0; j < 2; j++) {
          if (payload3.documents[0].images2[j].size !== null && payload3.documents[0].images2[j].size > 10485760) {
            this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
            return;
          }
          if (payload3.documents[0].images2[j].filename !== null) {
            if (payload3.documents[0].images2[j].filename.length > 100) {
              this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
              return;
            }
          }
        }
        for (let i = 0; i < 5; i++) {
          for (let j = 0; j < 2; j++) {
            if (payload3.documents2[i].images[j].size !== null && payload3.documents2[i].images[j].size > 10485760) {
              this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
              return;
            }
            if (payload3.documents2[i].images[j].filename !== null) {
              if (payload3.documents2[i].images[j].filename.length > 100) {
                this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
                return;
              }
            }
          }
        }
        if (payload3.documents3[0].images[0].size !== null && payload3.documents3[0].images[0].size > 10485760) {
          this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
          return;
        }
        if (payload3.documents3[0].images[0].filename !== null) {
          if (payload3.documents3[0].images[0].filename.length > 100) {
            this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
            return;
          }
        }

        const url = new Map();
        // #3212
        this.isLoading = true;
        if (this.uploadFlag1) {
          // 本人確認書類のアップロード
          for (let j = 0; j < 2; j++) {
            if (payload3.documents[0].images[j].binary) {
              // ext
              const extList = payload3.documents[0].images[j].filename.split('.');
              const ext = extList[extList.length - 1].toLowerCase();

              if (ext !== 'png' && ext !== 'jpeg' && ext !== 'jpg' && ext !== 'pdf') {
                this.isLoading = false;
                this.showErrorModal(
                  messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
                );
                return;
              }

              // filename
              let filename = '';
              const type = payload3.documents[0].type;
              if (type === IDENTIFICATION_OPTIONS[0].value) {
                const number = j + 1;
                filename = 'Driverlicense' + number;
              } else if (type === IDENTIFICATION_OPTIONS[1].value) {
                filename = 'MyNumber';
              }

              const result = await this.uploadImage(filename + '.' + ext, payload3.documents[0].images[j].binary);
              url.set(filename, result);
            }
          }
        }

        for (let j = 0; j < 2; j++) {
          if (payload3.documents[0].images2[j].binary) {
            // ext
            const extList = payload3.documents[0].images2[j].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'png' && ext !== 'jpeg' && ext !== 'jpg' && ext !== 'pdf') {
              this.isLoading = false;
              this.showErrorModal(
                messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
              );
              return;
            }

            // filename
            const type2 = payload3.documents[0].type2;
            let filename = Object.keys(this.certificateCollectionURL).find(
              key => this.certificateCollectionURL[key] === type2
            );

            if (filename === 'Driverlicense1' && j === 1) {
              filename = 'Driverlicense2';
            }

            if (filename === 'DrivingHistory1' && j === 1) {
              filename = 'DrivingHistory2';
            }

            const result = await this.uploadImage(filename + '.' + ext, payload3.documents[0].images2[j].binary);
            url.set(filename, result);
          }
        }

        if (payload.businessType === 'company' && this.uploadFlag2 === true) {
          // 登記事項証明書のアップロード
          let count = 1;
          for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 2; j++) {
              if (payload3.documents2[i].images[j].binary) {
                const extList = payload3.documents2[i].images[j].filename.split('.');
                const ext = extList[extList.length - 1].toLowerCase();

                if (ext !== 'pdf') {
                  this.isLoading = false;
                  this.showErrorModal(messageContent.requireChoice('PDFファイル'));
                  return;
                }

                const filename = 'Company' + count;
                const result = await this.uploadImage(filename + '.pdf', payload3.documents2[i].images[j].binary);

                if (result === 'error') {
                  this.isLoading = false;
                  this.showErrorModal(messageContent.requireChoice('PDFファイル'));
                  return;
                }

                url.set(filename, result);
                count++;
              }
            }
          }

          // 委任状のアップロード
          if (payload3.documents3[0].images[0].binary) {
            const extList = payload3.documents3[0].images[0].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'pdf') {
              this.isLoading = false;
              this.showErrorModal(messageContent.requireChoice('PDFファイル'));
              return;
            }

            const filename = 'LetterOfAttorney';
            const result = await this.uploadImage(filename + '.pdf', payload3.documents3[0].images[0].binary);
            url.set(filename, result);
          }
        }

        if (payload.businessType === 'company' && this.uploadFlag3 === true) {
          // 委任状のアップロード
          if (payload3.documents3[0].images[0].binary) {
            const extList = payload3.documents3[0].images[0].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'pdf') {
              this.isLoading = false;
              this.showErrorModal(messageContent.requireChoice('PDFファイル'));
              return;
            }

            const filename = 'LetterOfAttorney';
            const result = await this.uploadImage(filename + '.pdf', payload3.documents3[0].images[0].binary);
            url.set(filename, result);
          }
        }

        if (this.uploadFlag1) {
          payload2.certificateType = payload3.documents[0].type || '';
          payload2.certificateType2 = payload3.documents[0].type2 || '';
          payload2.DriverlicenseURL1 = url.get('Driverlicense1') || '';
          payload2.DriverlicenseURL2 = url.get('Driverlicense2') || '';
          payload2.MyNumberURL = url.get('MyNumber') || '';
          payload2.DrivingHistoryURL1 = url.get('DrivingHistory1') || '';
          payload2.DrivingHistoryURL2 = url.get('DrivingHistory2') || '';
          payload2.SealRegistrationURL = url.get('SealRegistration') || '';
          payload2.FamilyRegisterURL = url.get('FamilyRegister') || '';
          payload2.CertificateOfResidenceURL = url.get('CertificateOfResidence') || '';
        }

        if (payload.businessType === 'company' && (this.uploadFlag2 === true || this.uploadFlag3 === true)) {
          payload2.copyOfCompanyRegisterURL1 = url.get('Company1') || '';
          payload2.copyOfCompanyRegisterURL2 = url.get('Company2') || '';
          payload2.copyOfCompanyRegisterURL3 = url.get('Company3') || '';
          payload2.copyOfCompanyRegisterURL4 = url.get('Company4') || '';
          payload2.copyOfCompanyRegisterURL5 = url.get('Company5') || '';
          payload2.copyOfCompanyRegisterURL6 = url.get('Company6') || '';
          payload2.copyOfCompanyRegisterURL7 = url.get('Company7') || '';
          payload2.copyOfCompanyRegisterURL8 = url.get('Company8') || '';
          payload2.copyOfCompanyRegisterURL9 = url.get('Company9') || '';
          payload2.copyOfCompanyRegisterURL10 = url.get('Company10') || '';
          payload2.letterOfAttorneyURL = url.get('LetterOfAttorney') || '';
        }

        // historyCollectionのdocとcertificateCollectionのdocの登録
        const result = await this.createCollectionDocs(payload, payload2);

        const result2 = await this.sendMail(payload.businessType, result);
        if (!result2) {
          this.isLoading = false;
          throw new Error('error2');
        }
        // メールアドレスの変更のみで即時承認した場合は変更申し込み受付メールを送らない
        let msg = messageContent.notifyChangeApplyAccepted();
        if (!result.ret) {
          const usermailResult = await this.sendUserMail();
          if (!usermailResult) {
            this.isLoading = false;
            return;
          }
          msg = messageContent.notifyChangeContractAccepted();
        }
        this.isLoading = false;
        this.flagAplyButtonEnable = true;
        this.disableFlag = true;
        this.location = true;
        this.showInfoModal(msg);
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.showErrorModal(messageContent.requireTry('契約変更の申請'));
      }
    },
    // handleUploadFileChange(documentIndex, imageIndex, file) {
    handleUploadFileChange(document, imageIndex, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          // vm.formData.documents[documentIndex].images[imageIndex].binary = content;
          if (document === vm.formDataUpload.documents[0] && imageIndex >= 2) {
            document.images2[imageIndex - 2].binary = content;
          } else {
            document.images[imageIndex].binary = content;
          }
        },
        false
      );

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        if (document === this.formDataUpload.documents[0] && imageIndex >= 2) {
          document.images2[imageIndex - 2].filename = file[0].name;
          document.images2[imageIndex - 2].size = file[0].size;
        } else {
          document.images[imageIndex].filename = file[0].name;
          document.images[imageIndex].size = file[0].size;
        }
      } else {
        // clear file content
        // vm.formData.documents[documentIndex].images[imageIndex].file = null;
        // vm.formData.documents[documentIndex].images[imageIndex].binary = null;
        if (document === this.formDataUpload.documents[0] && imageIndex >= 2) {
          document.images2[imageIndex - 2].file = null;
          document.images2[imageIndex - 2].binary = null;
        } else {
          document.images[imageIndex].file = null;
          document.images[imageIndex].binary = null;
        }
      }
    },
    handleUploadFileChange1(documentIndex, imageIndex, file) {
      const doc = this.formDataUpload.documents[documentIndex];
      this.handleUploadFileChange(doc, imageIndex, file);
    },
    handleUploadFileChange2(documentIndex, imageIndex, file) {
      const doc = this.formDataUpload.documents2[documentIndex];
      this.handleUploadFileChange(doc, imageIndex, file);
    },
    handleUploadFileChange3(documentIndex, imageIndex, file) {
      const doc = this.formDataUpload.documents3[documentIndex];
      this.handleUploadFileChange(doc, imageIndex, file);
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/contract', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push({ path: '/contract' });
      }
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlist')
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の取得'));
        });
    },
    fetchContractDataHandler: async function () {
      await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
        authInfo: this.authInfo ? this.authInfo : '',
      })
        .then(e => {
          // this.formData = cloneDeep(e.data);
          // delete this.formData
          this.formData.adminBirthDate = e.data.adminBirthDate ? e.data.adminBirthDate.replaceAll('-', '') : '';

          // 都道府県名プルダウン値の処理
          let address1Msg = '';
          let found = this.prefectures.find(element => element.value === e.data.adminAddress1);
          if (typeof found === 'undefined') {
            address1Msg = messageContent.alertNotCorrectFormat('マスタ管理者:都道府県名') + '<br>';
            e.data.adminAddress1 = '';
          }

          found = this.prefectures.find(element => element.value === e.data.invoiceAddress1);
          if (typeof found === 'undefined') {
            address1Msg += messageContent.alertNotCorrectFormat('請求書送付先:都道府県名') + '<br>';
            e.data.invoiceAddress1 = '';
          }

          found = this.prefectures.find(element => element.value === e.data.companyAddress1);
          if (typeof found === 'undefined') {
            address1Msg += messageContent.alertNotCorrectFormat('法人情報:都道府県名');
            e.data.companyAddress1 = '';
          }

          if (address1Msg !== '') {
            this.showErrorModal(address1Msg);
          }

          this.formData.adminAddress1 = e.data.adminAddress1 || '';
          this.formData.adminAddress2 = e.data.adminAddress2 || '';
          this.formData.adminAddress3 = e.data.adminAddress3 || '';
          this.formData.adminAddress4 = e.data.adminAddress4 || '';
          this.formData.adminEmail = e.data.adminEmail || '';
          this.formData.adminJob = e.data.adminJob || '';

          // 職業を変換して値セット
          found = this.jobs.find(element => element.value === this.formData.adminJob);
          if (typeof found !== 'undefined') {
            this.formData.adminJob = found.label;
          }

          if (e.data.adminKanaName) {
            const kananame = e.data.adminKanaName.split('_');
            this.formData.lastname_kana = kananame[0];
            this.formData.name_kana = kananame[1];
          }
          if (e.data.adminName) {
            const name = e.data.adminName.split('_');
            this.formData.lastname = name[0];
            this.formData.name = name[1];
          }
          this.formData.adminPhoneNumber = e.data.adminPhoneNumber || '';
          this.formData.adminPostCode = e.data.adminPostCode || '';
          this.formData.billType = e.data.billType || '';
          this.formData.businessType = e.data.businessType || 'individual';
          this.formData.companyAddress1 = e.data.companyAddress1 || '';
          this.formData.companyAddress2 = e.data.companyAddress2 || '';
          this.formData.companyAddress3 = e.data.companyAddress3 || '';
          this.formData.companyAddress4 = e.data.companyAddress4 || '';
          this.formData.companyBusinessDetails = e.data.companyBusinessDetails || '';
          this.formData.companyKanaName = e.data.companyKanaName || '';
          this.formData.companyName = e.data.companyName || '';
          this.formData.companyPostCode = e.data.companyPostCode || '';
          this.formData.companyRelationship = e.data.companyRelationship || '';
          this.formData.companyRulerAddress = e.data.companyRulerAddress || '';
          this.formData.companyRulerBirthDate = e.data.companyRulerBirthDate || '';
          this.formData.companyRulerFlag = e.data.companyRulerFlag;
          this.formData.companyRulerName = e.data.companyRulerName || '';
          this.formData.contractStatus = e.data.contractStatus || '';
          this.formData.customerID = e.data.customerID || '';
          this.formData.invoiceAddress1 = e.data.invoiceAddress1 || '';
          this.formData.invoiceAddress2 = e.data.invoiceAddress2 || '';
          this.formData.invoiceAddress3 = e.data.invoiceAddress3 || '';
          this.formData.invoiceAddress4 = e.data.invoiceAddress4 || '';
          this.formData.invoiceName = e.data.invoiceName || '';
          this.formData.invoiceKanaName = e.data.invoiceKanaName || '';
          this.formData.invoicePhoneNumber = e.data.invoicePhoneNumber || '';
          this.formData.invoicePostCode = e.data.invoicePostCode || '';
          this.formData.note = e.data.note || '';
          this.formData.openDay = e.data.openDay || '';
          this.formData.purposeOfUse = e.data.purposeOfUse || '';
          this.formData.responderName = e.data.responderName || '';
          this.formData.startDate = e.data.startDate || '';
          this.formData.voicedxOnlyFlag = e.data.voicedxOnlyFlag;
          this.formData.salesChannelCode = e.data.salesChannelCode || '';
          this.formData.salesPersonCode = e.data.salesPersonCode || '';

          if (e.data.companyRulerFlag === true) {
            this.radio = 'true';
          } else {
            if (e.data.companyRulerFlag === 'true') {
              this.radio = 'true';
            } else {
              this.radio = 'false';
            }
          }

          if (this.radio === 'true') {
            this.companyRulerFlag = true;
            this.formData.companyRulerFlag = true;
          } else {
            this.companyRulerFlag = false;
            this.formData.companyRulerFlag = false;
          }

          let companyRulerNo = '';
          const arrInput = ['companyRulerName', 'companyRulerAddress', 'companyRulerBirthDate', 'companyRelationship'];
          for (let i = 0; i < 4; i++) {
            if (i > 0) {
              companyRulerNo = String(i + 1);
            }

            for (let j = 0; j < arrInput.length; j++) {
              if (typeof e.data[arrInput[j] + companyRulerNo] === 'undefined') {
                this.formData[arrInput[j] + companyRulerNo] = '';
              } else {
                this.formData[arrInput[j] + companyRulerNo] = e.data[arrInput[j] + companyRulerNo];
              }
            }

            if (this.formData['companyRulerName' + companyRulerNo] === '') {
              this.companyRuler[i + 1] = false;
            } else {
              this.companyRuler[i + 1] = true;
            }

            this.formData['companyRulerBirthDateView' + companyRulerNo] = this.formData[
              'companyRulerBirthDate' + companyRulerNo
            ].replace(/-/g, '');
          }

          if (e.data.contractStatus === 'close') {
            this.contractStatusFlag = true;
            this.showErrorModal(messageContent.alertNowCanceling());
          }

          this.formOrgData = cloneDeep(this.formData);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報取得'));
        });
    },
    checkContractStatus: async function () {
      return await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.data.contractStatus === 'close') {
            this.contractStatusFlag = true;
            this.showErrorModal(messageContent.alertNowCanceling());
            return false;
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
    checkSoStatus: async function () {
      return await this.postRequest('/contract/checksostatus', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.soStatusFlag = true;
            this.showErrorModal(messageContent.alertNowApplying());
            return false;
          }
          this.soStatusFlag = false;
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
    checkAdminEmail: async function (adminEmail) {
      return await this.postRequest('/contract/checkadminemail', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
        adminEmail: adminEmail,
      }).then(e => {
        if (e.status === 'failed') {
          if (e.msg) {
            this.showErrorModal(e.msg);
          }
          return null;
        }
        return true;
      });
    },
    validateParamIndividual: async function (formData) {
      return await this.postRequest('/contract/validateIndividual', {
        data: formData,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      }).then(e => {
        if (e.status === 'failed') {
          if (e.msg) {
            this.showErrorModal(e.msg);
          }
          return null;
        }
        return true;
      });
    },
    validateParamHoujin: async function (formData) {
      return await this.postRequest('/contract/validateHoujin', {
        data: formData,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      }).then(e => {
        if (e.status === 'failed') {
          if (e.msg) {
            this.showErrorModal(e.msg);
          }
          return null;
        }
        return true;
      });
    },
    uploadImage: async function (path, binary) {
      return await this.postRequest('/contract/uploaddocumentforupdate', {
        path: path,
        binary: binary,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      }).then(e => {
        if (e.status === 'failed') {
          return 'error';
        }
        return e.result;
      });
    },
    createCollectionDocs: async function (historyData, certificateData) {
      return await this.postRequest('/contract/createcollectiondocsforcontract', {
        data: historyData,
        data2: certificateData,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error(messageContent.httpRequestError('/contract/createcollectiondocsforcontract'));
        }

        this.formOrgData.adminEmail = this.formData.adminEmail;
        return e;
      });
    },
    sendMail: async function (businessType, result) {
      return await this.postRequest('/contract/sendoperatormailforupdate', {
        orderType: businessType,
        tmpYMD: result.result,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
        originalData: this.formOrgData,
        flgApproval: result.ret,
        adminEmail: this.adminEmail,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error(messageContent.httpRequestError('/contract/sendoperatormailforupdate'));
        }
        return true;
      });
    },
    sendUserMail: async function () {
      return await this.postRequest('/contract/sendusermailforupdate', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            throw new Error(messageContent.httpRequestError('/contract/sendusermailforupdate'));
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
    chkSpecialCharacter: function (payload) {
      for (const item of this.spCharCheckListRuler) {
        if (this.hasSpecialCharacterInObject({ keyWord: payload[item.fieldName] })) {
          return item.name;
        }
      }
      return '';
    },
    showConfirmModal(message) {
      this.confirmModalVisible = true;
      this.confirmModalTitle = '契約情報変更の確認';
      this.confirmModalContent = message;
    },
    showConfirmModal2(message) {
      this.confirmModalVisible2 = true;
      this.confirmModalTitle = '契約情報変更の確認';
      this.confirmModalContent = message;
    },
    handleUpdateEmail: async function (e) {
      this.confirmModalVisible = false;
      this.confirmModalVisible2 = false;
      this.confirmModalTitle = '契約情報変更の確認';
      this.confirmModalContent = '';
      await this.handleFormSubmit2(e);
    },
  },
};
</script>
